import * as React from "react";
export function withRoot(Component: any) {
	function WithRoot(props: object) {
		return (
				<Component {...props} />
		);
	}
	return WithRoot;
}
